import React from "react";

const PageContent = ({ children, loading, className }) => {
  return (
    <div
      className={`${loading ? "opacity-40" : ""} ${
        className || "mb-5 shadow-md bg-white"
      }`}
    >
      {children}
    </div>
  );
};

export default PageContent;
